/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from '@ali-hm/angular-tree-component';

@Component({
  standalone: false,
  selector: 'gh-tree-node-dnd-pointer',
  template: '<mat-icon *ngIf="node.allowDrag()" svgIcon="gh:dnd-pointer"></mat-icon>',
})
export class TreeNodeDndPointerComponent {
  @Input() node: TreeNode;
}
